import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import CustomCol from '../../../../../components/CustomCol';
import CustomInputDate from '../../../../../components/CustomInputs/CustomInputDate';
import CustomInputText from '../../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../../components/CustomRow';
import CustomSelect from '../../../../../components/CustomSelects/CustomSelect';
import StyledLink from '../../../../../components/Link';
import Log from '../../../../../components/Log/Log';
import SubAbas from '../../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { useSelect } from '../../../../../modules/contexts/Select/useSelect';
import {
  ISetorDafForm,
  ISetorDafRegistro,
} from '../../../../../modules/types/SetorDaf';
import { getSetorDafById } from '../../../../../services/setoresDaf/setoresDafService';
import theme from '../../../../../theme';
import { functionLogData } from '../../../../../utils/functionLogData';
import { formatDateForInput } from '../../../../../utils/functions';
import { handleDelete } from '../../../../../utils/handleDelete';
import { handleSave } from '../../../../../utils/handleSave';
import {
  optionStatusBin,
  optionStatusBinSimNao,
} from '../../Dominios/utils/optionStatusBin';
import { defaultSetorDafFormMain } from '../utils/formSetorDafDefault';
import SubAbasSetoresDaf from '../utils/subabasCores';

export default function SetorDafIdentificacao() {
  //COMPONENTE
  const params = useParams();
  const fichaID = String(params.id);

  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  const { getSelectDominioPai } = useSelect();
  const componentesAf = getSelectDominioPai(1);

  const [logData, setLogData] = useState<ISetorDafRegistro | null>(null);

  // FORMULÁRIO
  const [dataRaw, setDataRaw] = useState<ISetorDafForm | null>(null);
  const [formMain, setFormMain] = useState<ISetorDafForm>(
    defaultSetorDafFormMain,
  );

  //Buscar dados
  const fetchData = async (id: string | number): Promise<void> => {
    try {
      const registroData: ISetorDafRegistro = await getSetorDafById(String(id));
      setLogData(registroData);

      const formValues: ISetorDafForm = {
        id: registroData.id,
        restricaoComponenteAf: registroData.restricaoComponenteAf,
        componenteAfId: registroData.componenteAfId,
        status: registroData.status,
        sigla: registroData.sigla,
        nomeSetorDaf: registroData.nomeSetorDaf,
        dataCriacao: formatDateForInput(registroData.dataCriacao),
        dataExtincao: formatDateForInput(registroData.dataExtincao),
        descricao: registroData.descricao,
        observacoes: registroData.observacoes,
      };

      setFormMain(formValues);
      setDataRaw(formValues);
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    if (fichaID !== 'undefined') {
      fetchData(fichaID);
    }
  }, [fichaID]);

  const subAbas =
    fichaID !== 'undefined'
      ? SubAbasSetoresDaf(fichaID)
      : [
          {
            label: 'Dados Gerais',
            rota: `/daf/adm/setores/setor/dadosgerais`,
          },
        ];

  const logs = functionLogData(logData);

  const [componenteAfObrigatorio, setComponenteAfObrigatorio] = useState(false);
  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;

    if (name === 'status' && Number(value) === 2) {
      setFormMain((prevState) => ({
        ...prevState,
        dataExtincao: formatDateForInput(new Date().toISOString()),
      }));
    } else if (name === 'status' && Number(value) !== 2) {
      setFormMain((prevState) => ({
        ...prevState,
        dataExtincao: '',
      }));
    }

    setFormMain((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const camposBaseObrigatorios: Record<string, string> = {
    status: 'Status',
    dataCriacao: 'Data de Criação',
    restricaoComponenteAf: 'Restrição Componente AF',
    sigla: 'Sigla',
    nomeSetorDaf: 'Nome do Setor DAF',
  };

  const camposBaseAjustar = {
    number: ['id', 'usuarioId', 'status', 'restricaoComponenteAf'],
    string: ['sigla', 'nomeSetorDaf', 'observacoes'],
    date: ['dataCriacao', 'dataExtincao'],
  };

  const [camposObrigatorios, setCamposObrigatorios] = useState<
    Record<string, string>
  >(camposBaseObrigatorios);

  const [camposAjustar, setCamposAjustar] = useState(camposBaseAjustar);

  useEffect(() => {
    if (Number(formMain.restricaoComponenteAf) === 1) {
      setComponenteAfObrigatorio(true);

      // 1. Campos obrigatórios
      setCamposObrigatorios({
        ...camposBaseObrigatorios,
        componenteAfId: 'Componente AF',
      });

      // 2. Campos number ajustados
      setCamposAjustar((prev) => ({
        ...prev,
        number: Array.from(new Set([...prev.number, 'componenteAfId'])), // evita duplicação
      }));
    } else {
      setComponenteAfObrigatorio(false);

      // 1. Remove campo obrigatório
      setCamposObrigatorios(camposBaseObrigatorios);

      // 2. Remove de number
      setCamposAjustar((prev) => ({
        ...prev,
        number: prev.number.filter((x) => x !== 'componenteAfId'),
      }));

      setFormMain((prevState) => ({
        ...prevState,
        componenteAfId: 0,
      }));
    }
  }, [formMain.restricaoComponenteAf]);

  const salvar = () =>
    handleSave(
      formMain,
      camposObrigatorios,
      camposAjustar,
      'setores-daf',
      'daf/adm/setores/setor',
      fetchData,
      true,
      dataRaw,
    );

  const deletar = () => handleDelete(fichaID, 'setores-daf', 'daf/adm/setores');

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/adm/setores"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        {logs && (
          <Log
            {...logs}
            entity="TB_SETOR_DAF"
            id={Number(formMain.id)}
            refreshTriggerLog={refreshTriggerLog}
          />
        )}
        {/* Identificação do Domínio */}
        <BoxConteudo boxTitulo="Identificação da Setor DAF">
          <CustomRow
            style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
          >
            <CustomCol width="200px">
              <CustomSelect
                name="status"
                options={optionStatusBin}
                title="Status"
                value={formMain.status}
                onChange={handleChange}
                required
                style={{
                  backgroundColor:
                    Number(formMain.status) === 2
                      ? theme.colors.vermelho
                      : Number(formMain.status) === 1
                        ? theme.colors.verde
                        : 'white',
                  color: Number(formMain.status) === 0 ? '#000000' : '#ffffff',
                }}
              />
            </CustomCol>
            <CustomCol width="180px">
              <CustomInputDate
                name="dataCriacao"
                title="Data de Criação"
                value={formMain.dataCriacao}
                onChange={handleChange}
                required
              />
            </CustomCol>
            <CustomCol width="180px">
              <CustomInputDate
                name="dataExtincao"
                title="Data de Extinção"
                value={formMain.dataExtincao}
                onChange={handleChange}
                minDate={
                  formMain.dataCriacao
                    ? new Date(formMain.dataCriacao)
                    : undefined
                }
                readOnly={Number(formMain.status) !== 2}
              />
            </CustomCol>
            <CustomCol width="200px">
              <CustomSelect
                name="restricaoComponenteAf"
                options={optionStatusBinSimNao}
                title="Restrição Componente AF"
                value={formMain.restricaoComponenteAf}
                onChange={handleChange}
                required
              />
            </CustomCol>
            <CustomCol width="200px">
              <CustomSelect
                name="componenteAfId"
                options={componentesAf}
                title="Componente AF"
                value={formMain.componenteAfId}
                onChange={handleChange}
                disabled={componenteAfObrigatorio ? false : true}
                required={componenteAfObrigatorio}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol width="200px">
              <CustomInputText
                name="sigla"
                value={formMain.sigla}
                title="Sigla"
                onChange={handleChange}
                required
              />
            </CustomCol>
            <CustomCol>
              <CustomInputText
                name="nomeSetorDaf"
                value={formMain.nomeSetorDaf}
                title="Nome do Setor DAF"
                onChange={handleChange}
                required
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol>
              <CustomInputText
                name="descricao"
                value={formMain.descricao}
                title="Descrição"
                type="textArea"
                onChange={handleChange}
                rows={5}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol>
              <CustomInputText
                name="observacoes"
                value={formMain.observacoes}
                title="Observações"
                type="textArea"
                onChange={handleChange}
                rows={3}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={deletar}
            save
            onClickSave={salvar}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={salvar} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
